The details of the updated position opening.
